import { render, staticRenderFns } from "./targetAdsetTree.vue?vue&type=template&id=2f89f404&scoped=true"
import script from "./targetAdsetTree.vue?vue&type=script&lang=js"
export * from "./targetAdsetTree.vue?vue&type=script&lang=js"
import style0 from "./targetAdsetTree.vue?vue&type=style&index=0&id=2f89f404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89f404",
  null
  
)

export default component.exports